<template>
  <div class="avatarUpload">
    <div class="avatarUpload__image" @click="onFocus">
      <i v-if="!selectedFile" class="icon-user"></i>
      <div v-else :style="'background-image:url(' + tmpImage + ')'"></div>
    </div>
    <div class="avatarUpload__label">
      <small>Resolution 72x72 px.</small>
      <InputText
        v-model="selectedFileName"
        type="text"
        placeholder="Upload photo"
        readonly
        @click="onFocus"
      />
    </div>
    <button v-if="!selectedFile" class="avatarUpload__button" @click="onFocus">
      <i class="pi pi-upload"></i>
    </button>
    <button v-else class="avatarUpload__button" @click="removeFile">
      <i class="icon-x"></i>
    </button>

    <input
      ref="uploader"
      class="avatarUpload__file"
      accept="image/*, application/pdf"
      type="file"
      @change="file"
    />
  </div>
</template>
<script>
export default {
  data: () => ({
    selectedFile: null,
    selectedFileName: null,
    tmpImage: null,
  }),
  methods: {
    onFocus() {
      this.$refs.uploader.click();
    },
    file(e) {
      this.selectedFile = e.target.files[0];
      this.selectedFileName = this.selectedFile.name;

      var reader = new FileReader();
      reader.readAsDataURL(this.selectedFile);
      reader.onload = () => {
        this.tmpImage = reader.result;
      };
    },
    removeFile() {
      this.selectedFile = null;
      this.selectedFileName = null;
    },
  },
};
</script>
